import ProfileContainer from '../components/ProfileContainer'

export default ProfileContainer